import { apiClient } from "./fetch";

/**
 * Booking updates (Admin Panel > TrueCare): rules of booking statuses -> staff
 * WhatsApp numbers. MasterAdmin only (the API enforces it). Same dual mount as
 * programs: /api/v1/booking-alerts rides apiClient's base; hospital_id is in the
 * path for the tenant guard.
 */
export type BookingAlertEvent = "booking" | "walkin" | "cancel" | "reschedule";

export interface BookingAlertRule {
  rule_id: string;
  label: string | null;
  events: BookingAlertEvent[];
  phones: string[]; // digits with country code, e.g. "919876543210"
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface BookingAlertConfig {
  enabled: boolean; // hospital_feature_flags.booking_alerts
  rules: BookingAlertRule[];
}

export type BookingAlertRuleInput = {
  label?: string | null;
  events?: BookingAlertEvent[];
  phones?: string[];
  enabled?: boolean;
};

export const getBookingAlerts = (hospitalId: string) =>
  apiClient.get(`/booking-alerts/${hospitalId}`);

export const createBookingAlertRule = (hospitalId: string, body: BookingAlertRuleInput) =>
  apiClient.post(`/booking-alerts/${hospitalId}`, body);

export const updateBookingAlertRule = (hospitalId: string, ruleId: string, body: BookingAlertRuleInput) =>
  apiClient.patch(`/booking-alerts/${hospitalId}/${ruleId}`, body);

export const deleteBookingAlertRule = (hospitalId: string, ruleId: string) =>
  apiClient.delete(`/booking-alerts/${hospitalId}/${ruleId}`);
